/* Chez Smash — choix « Livraison » ou « À emporter », minimum de commande selon la distance
 * (fenêtre adresse + carte, encart panier).
 * Les paliers, le point de départ et l'activation viennent du service de commande (/livraison/config).
 * Le service recalcule tout au moment de la commande : ce fichier ne sert qu'à informer le client. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfgEl = $('#cs-config');
  const endpoint = ((cfgEl && cfgEl.dataset.endpoint) || '').trim().replace(/\/+$/, '');
  if (!endpoint) return;

  const params = new URLSearchParams(location.search);
  const isPreview = !!((window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || params.has('preview_theme_id') || (window.Shopify && Shopify.designMode));
  const KEY = 'cs_delivery';
  const MAX_AGE = 30 * 24 * 3600 * 1000;
  const COLORS = ['#22a447', '#f08c00', '#e03131', '#7048e8', '#1c7ed6', '#0ca678', '#d6336c', '#495057'];
  const eur = (c) => { const v = (c || 0) / 100; return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: Number.isInteger(v) ? 0 : 2 }).format(v); };
  const eur2 = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((c || 0) / 100);
  const km1 = (k) => (Math.round(k * 10) / 10).toFixed(1).replace('.', ',');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------------- Réglages (source unique : le service) ---------------- */
  let CFG = null;
  const cfgP = fetch(`${endpoint}/livraison/config`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json()).then((c) => { if (c && Array.isArray(c.tiers)) CFG = c; return CFG; }).catch(() => null);
  const enabled = () => !!(CFG && (CFG.active || isPreview));
  // Vente à emporter : proposée quand Chez Smash l'active dans ses réglages (toujours visible en aperçu de thème).
  const pickupOn = () => !!(CFG && CFG.pickup && (CFG.pickup.active || isPreview));
  const pickupCfg = () => (CFG && CFG.pickup) || { min_cents: 0, label: '' };
  const MODE_KEY = 'cs_mode';
  let memMode = '';
  const getMode = () => { let m = memMode; try { m = localStorage.getItem(MODE_KEY) || memMode; } catch (e) { /* stockage bloqué */ } return m === 'emporter' && pickupOn() ? 'emporter' : 'livraison'; };
  const setMode = (m) => { memMode = m === 'emporter' ? 'emporter' : 'livraison'; try { localStorage.setItem(MODE_KEY, memMode); } catch (e) { /* */ } document.dispatchEvent(new CustomEvent('csd:change', { detail: { mode: memMode } })); };
  const originCity = () => { const l = (CFG && CFG.origin && CFG.origin.label) || ''; const m = /\d{5}\s+(.+)$/.exec(l); return m ? m[1].trim() : ''; };
  // Minimum « à la minute » (30/10/2026) : minutes de trajet × 2 (aller + retour) × prix par minute. Le service fait foi.
  const minutesMode = () => !!(CFG && CFG.min_mode === 'minutes');
  const perMin = () => (CFG && Number.isFinite(+CFG.per_min_cents) ? +CFG.per_min_cents : 100);
  const trips = () => (CFG && CFG.round_trip === false ? 1 : 2);
  const minFromMinutes = (m) => Math.max(1, Math.round(+m || 0)) * trips() * perMin();
  const tierFor = (km) => { if (!CFG) return null; const i = CFG.tiers.findIndex((t) => km <= t.max_km + 1e-9); return i < 0 ? null : { index: i, ...CFG.tiers[i] }; };

  /* ---------------- Adresse mémorisée (sur cet appareil) ---------------- */
  let memory = null;
  const load = () => {
    let s = memory;
    try { s = JSON.parse(localStorage.getItem(KEY) || 'null') || memory; } catch (e) { /* stockage bloqué */ }
    if (!s || !Number.isFinite(s.distance_km) || Date.now() - (s.at || 0) > MAX_AGE) return null;
    const t = tierFor(s.distance_km);
    if (!t) return { ...s, out: true };
    const min = minutesMode() && s.duration_min > 0 ? minFromMinutes(s.duration_min) : t.min_cents;
    return { ...s, min_cents: min, fee_cents: t.fee_cents, tier_index: t.index };
  };
  const save = (s) => {
    memory = s;
    try {
      localStorage.setItem(KEY, JSON.stringify(s));
      // pré-remplit la page « Finaliser ma commande »
      const c = JSON.parse(localStorage.getItem('cs_client') || '{}');
      Object.assign(c, { address1: s.name, zip: s.postcode, city: s.city });
      localStorage.setItem('cs_client', JSON.stringify(c));
    } catch (e) { /* stockage bloqué : on garde en mémoire */ }
    document.dispatchEvent(new CustomEvent('csd:change', { detail: s }));
  };
  const clear = () => { memory = null; try { localStorage.removeItem(KEY); } catch (e) { /* */ } document.dispatchEvent(new CustomEvent('csd:change', { detail: null })); };

  window.CSDelivery = { endpoint, isPreview, ready: cfgP, enabled, load, config: () => CFG, open: (o) => openModal(o || {}), pickupOn, pickup: pickupCfg, mode: getMode, setMode };

  /* ---------------- Carte (Leaflet + Plan IGN, chargés seulement à l'ouverture) ---------------- */
  let leafletP = null;
  const loadLeaflet = () => leafletP || (leafletP = new Promise((res, rej) => {
    if (window.L) return res(window.L);
    const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css'; document.head.appendChild(css);
    const js = document.createElement('script'); js.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js'; js.async = true;
    js.onload = () => res(window.L); js.onerror = () => { leafletP = null; rej(new Error('carte')); }; document.head.appendChild(js);
  }));
  let map = null, meLayer = null, routeLayer = null;
  async function initMap() {
    const box = $('[data-csd-map]'); if (!box || !CFG) return;
    let L;
    try { L = await loadLeaflet(); } catch (e) { box.innerHTML = '<p style="padding:90px 16px;margin:0;color:#5c6370;font-size:14px">Carte indisponible pour le moment. Le calcul de distance fonctionne quand même.</p>'; return; }
    if (map) { map.invalidateSize(); return; }
    const o = [CFG.origin.lat, CFG.origin.lon];
    map = L.map(box, { zoomControl: false, attributionControl: true, scrollWheelZoom: false, tap: true }).setView(o, 11);
    L.tileLayer('https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/png&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
      { maxZoom: 18, attribution: '© <a href="https://www.ign.fr" target="_blank" rel="noopener">IGN</a>' }).addTo(map);
    L.control.zoom({ position: 'bottomright' }).addTo(map);
    const rings = CFG.tiers.map((t, i) => ({ t, i })).reverse();
    let outer = null;
    rings.forEach(({ t, i }) => {
      const c = L.circle(o, { radius: t.max_km * 1000, color: COLORS[i % COLORS.length], weight: 1.5, opacity: 0.55, fillColor: i === 0 ? '#9be3a8' : '#ffd21a', fillOpacity: i === 0 ? 0.22 : 0.14, interactive: false }).addTo(map);
      if (!outer) outer = c;
    });
    const parts = (CFG.origin.label || '').split(',');
    L.marker(o, { icon: L.divIcon({ className: 'csd-pin', iconSize: [26, 26], iconAnchor: [4, 30],
      html: `<div class="csd-pin__dot"></div><div class="csd-pin__lbl">Chez Smash<small>${esc(parts[0] || '')}</small><small>${esc((parts[1] || '').trim())}</small></div>` }), keyboard: false }).addTo(map);
    if (outer) map.fitBounds(outer.getBounds(), { padding: [6, 6] });
    const st = load(); if (st && st.route) drawRoute(st);
  }
  function drawRoute(s) {
    if (!map || !window.L) return;
    const L = window.L;
    if (meLayer) meLayer.remove(); if (routeLayer) routeLayer.remove();
    meLayer = L.marker([s.lat, s.lon], { icon: L.divIcon({ className: '', html: '<div class="csd-me"></div>', iconSize: [18, 18], iconAnchor: [9, 9] }), keyboard: false }).addTo(map);
    if (Array.isArray(s.route) && s.route.length > 1) {
      routeLayer = L.layerGroup([
        L.polyline(s.route, { color: '#111', weight: 7, opacity: 0.85 }),
        L.polyline(s.route, { color: '#ffd21a', weight: 3.5, opacity: 1 }),
      ]).addTo(map);
      map.fitBounds(L.latLngBounds(s.route), { paddingTopLeft: [24, 64], paddingBottomRight: [24, 24], maxZoom: 15 });
    } else map.setView([s.lat, s.lon], 14);
  }

  /* ---------------- Fenêtre « Votre adresse de livraison » ---------------- */
  const modal = $('[data-csd-modal]');
  let mode = 'menu', goHref = '/collections/all', lastFocus = null, current = null;

  function renderTiers(active) {
    const ul = $('[data-csd-tiers]', modal); if (!ul || !CFG) return;
    const box = ul.closest('.csd-tiers');
    // Minimum à la minute : seul le montant est montré au client, jamais le détail du calcul.
    if (box) box.style.display = minutesMode() ? 'none' : '';
    if (minutesMode()) return;
    $('[data-csd-tiers-title]', modal).textContent = CFG.confirmed ? 'Tarif minimum de livraison' : 'Exemples de tarif minimum de livraison';
    ul.innerHTML = CFG.tiers.map((t, i) => {
      const from = i ? CFG.tiers[i - 1].max_km : 0;
      return `<li class="${active === i ? 'is-on' : ''}"><span class="csd-dot" style="background:${COLORS[i % COLORS.length]}"></span><span>${km1(from).replace(',0', '')} – ${km1(t.max_km).replace(',0', '')} km</span><span class="csd-arrow" aria-hidden="true">→</span><span><strong>${eur(t.min_cents)}</strong> minimum${t.fee_cents ? ` <small>· frais ${eur(t.fee_cents)}</small>` : ''}</span></li>`;
    }).join('');
  }
  function showResult(cls, html) { const r = $('[data-csd-result]', modal); r.hidden = !html; r.className = 'csd-result ' + cls; r.innerHTML = html || ''; }
  function setGo(on) { $('[data-csd-go]', modal).disabled = !on; }
  function okHtml(s) {
    const city = originCity();
    return `<span class="csd-big">Commande minimum : ${eur(s.min_cents)}</span>Vous êtes à <strong>${km1(s.distance_km)} km</strong> de Chez Smash${city ? ` (${esc(city)})` : ''} par la route${s.duration_min && !minutesMode() ? `, ≈ ${s.duration_min} min` : ''}. Livraison ${s.fee_cents ? `: <strong>${eur2(s.fee_cents)}</strong>` : '<strong>offerte</strong>'}.` +
      (s.precise === false ? '<br><small>Astuce : ajoutez le numéro de rue pour un calcul exact.</small>' : '');
  }

  async function openModal(opts) {
    if (!modal) { if (opts.href) location.href = opts.href; return; }
    mode = opts.mode || 'menu'; goHref = opts.href || goHref;
    lastFocus = document.activeElement;
    modal.hidden = false; document.body.classList.add('csd-lock');
    $('[data-csd-go-label]', modal).textContent = mode === 'cart' ? 'Valider cette adresse' : 'Voir le menu';
    await cfgP;
    $('[data-csd-preview]', modal).hidden = !(CFG && !CFG.active);
    const st = load();
    current = st && !st.out ? st : null;
    renderTiers(current ? current.tier_index : -1);
    if (current) { $('[data-csd-input]', modal).value = current.label; showResult('is-ok', okHtml(current)); setGo(true); }
    else { showResult('', ''); setGo(false); }
    setTimeout(() => { initMap(); if (!current) $('[data-csd-input]', modal).focus({ preventScroll: true }); }, 60);
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true; document.body.classList.remove('csd-lock'); hideList();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Autocomplétion (adresses officielles, Base Adresse Nationale) */
  const input = modal && $('[data-csd-input]', modal);
  const list = modal && $('[data-csd-list]', modal);
  let sugg = [], sel = -1, timer = null, seq = 0;
  function hideList() { if (list) { list.hidden = true; input.setAttribute('aria-expanded', 'false'); sel = -1; } }
  function renderList(msg) {
    list.innerHTML = '';
    if (msg) { const li = document.createElement('li'); li.className = 'is-msg'; li.textContent = msg; list.appendChild(li); }
    sugg.forEach((s, i) => {
      const li = document.createElement('li'); li.id = 'csd-o' + i; li.setAttribute('role', 'option'); li.setAttribute('aria-selected', String(i === sel));
      const rest = s.label.replace(s.name, '').trim();
      li.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style="flex:0 0 auto;margin-top:2px"><path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12Z" fill="none" stroke="currentColor" stroke-width="2"/></svg><span>${esc(s.name)}<small>${esc(rest)}</small></span>`;
      li.addEventListener('mousedown', (e) => e.preventDefault());
      li.addEventListener('click', () => choose(s));
      list.appendChild(li);
    });
    list.hidden = !msg && !sugg.length; input.setAttribute('aria-expanded', String(!list.hidden));
  }
  async function search(q) {
    const my = ++seq;
    try {
      const r = await fetch(`${endpoint}/adresse?q=${encodeURIComponent(q)}`, { headers: { Accept: 'application/json' } });
      const j = await r.json(); if (my !== seq) return;
      sugg = j.results || []; sel = -1;
      renderList(!j.ok ? (j.message || 'Recherche indisponible pour le moment.') : (sugg.length ? '' : 'Aucune adresse trouvée près de Metz. Vérifiez l’orthographe.'));
    } catch (e) { if (my === seq) { sugg = []; renderList('Recherche d’adresse indisponible. Vérifiez votre connexion.'); } }
  }
  if (input) {
    input.addEventListener('input', () => {
      clearTimeout(timer); setGo(false); current = null;
      const q = input.value.trim();
      if (q.length < 3) { sugg = []; hideList(); return; }
      timer = setTimeout(() => search(q), 230);
    });
    input.addEventListener('keydown', (e) => {
      if (list.hidden || !sugg.length) { if (e.key === 'Enter') e.preventDefault(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + sugg.length) % sugg.length; renderList(); input.setAttribute('aria-activedescendant', 'csd-o' + sel); }
      else if (e.key === 'Enter') { e.preventDefault(); choose(sugg[Math.max(0, sel)]); }
      else if (e.key === 'Escape') hideList();
    });
    input.addEventListener('blur', () => setTimeout(hideList, 150));
  }

  async function choose(s) {
    hideList(); input.value = s.label; input.blur();
    setGo(false); showResult('is-info', 'Calcul de la distance par la route…');
    let q;
    try {
      const r = await fetch(`${endpoint}/livraison`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ address1: s.name, zip: s.postcode, city: s.city, preview: isPreview, route: true }) });
      q = await r.json();
    } catch (e) { q = { ok: false, reason: 'service', message: 'Impossible de calculer la distance pour le moment. Vérifiez votre connexion et réessayez.' }; }
    if (q.ok && Number.isFinite(q.distance_km)) {
      current = { label: q.address.label, name: q.address.name || s.name, postcode: q.address.postcode || s.postcode, city: q.address.city || s.city,
        lat: q.address.lat, lon: q.address.lon, precise: q.address.precise, distance_km: q.distance_km, duration_min: q.duration_min,
        min_cents: q.min_cents, fee_cents: q.fee_cents, tier_index: q.tier_index, route: q.route || null, at: Date.now() };
      save(current); renderTiers(current.tier_index); showResult('is-ok', okHtml(current)); setGo(true); drawRoute(current);
    } else {
      current = null;
      if (q.reason === 'zone' && q.address) { clear(); drawRoute({ ...q.address, route: q.route }); }
      renderTiers(-1);
      showResult(q.reason === 'service' ? 'is-info' : 'is-ko', esc(q.message || 'Adresse non reconnue.'));
      if (q.reason === 'service' && mode === 'menu') { $('[data-csd-go-label]', modal).textContent = 'Voir le menu'; setGo(true); }
    }
  }

  if (modal) {
    $$('[data-csd-close]', modal).forEach((b) => b.addEventListener('click', closeModal));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden && list.hidden) closeModal(); });
    $('[data-csd-go]', modal).addEventListener('click', () => {
      if (mode === 'cart') { closeModal(); renderCart(); return; }
      location.href = goHref || '/collections/all';
    });
    const gps = $('[data-csd-gps]', modal);
    if (!('geolocation' in navigator)) gps.hidden = true;
    gps.addEventListener('click', () => {
      gps.classList.add('is-busy'); showResult('is-info', 'Recherche de votre position…');
      navigator.geolocation.getCurrentPosition(async (p) => {
        try {
          const j = await (await fetch(`${endpoint}/adresse?lat=${p.coords.latitude}&lon=${p.coords.longitude}`)).json();
          gps.classList.remove('is-busy');
          if (j.results && j.results[0]) choose(j.results[0]); else showResult('is-ko', 'Adresse introuvable à votre position : saisissez-la.');
        } catch (e) { gps.classList.remove('is-busy'); showResult('is-ko', 'Localisation indisponible : saisissez votre adresse.'); }
      }, () => { gps.classList.remove('is-busy'); showResult('is-ko', 'Position refusée ou indisponible : saisissez votre adresse.'); }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
    });
  }

  /* ---------------- Fenêtre « Livraison ou à emporter ? » ---------------- */
  const choice = $('[data-csm-modal]');
  let choiceHref = '/collections/all', choiceFocus = null;
  function openChoice(href) {
    if (!choice) { openModal({ mode: 'menu', href }); return; }
    choiceHref = href || '/collections/all'; choiceFocus = document.activeElement;
    const p = pickupCfg();
    const lbl = $('[data-csm-pickup-txt]', choice);
    if (lbl) lbl.textContent = `Retrait au restaurant${p.label ? ' : ' + p.label : ''}${p.min_cents ? ` · minimum ${eur(p.min_cents)}` : ''}`;
    const prev = $('[data-csm-preview]', choice); if (prev) prev.hidden = !(CFG && CFG.pickup && !CFG.pickup.active);
    choice.hidden = false; document.body.classList.add('csd-lock');
    const first = $('[data-csm-pick]', choice); if (first) first.focus({ preventScroll: true });
  }
  function closeChoice(back) {
    if (!choice || choice.hidden) return;
    choice.hidden = true; document.body.classList.remove('csd-lock');
    if (back && choiceFocus && choiceFocus.focus) choiceFocus.focus({ preventScroll: true });
  }
  if (choice) {
    $$('[data-csm-close]', choice).forEach((b) => b.addEventListener('click', () => closeChoice(true)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !choice.hidden) closeChoice(true); });
    $$('[data-csm-pick]', choice).forEach((b) => b.addEventListener('click', () => {
      const m = b.dataset.csmPick;
      setMode(m); closeChoice(false);
      if (m === 'emporter' || !enabled()) { location.href = choiceHref; return; }
      openModal({ mode: 'menu', href: choiceHref });
    }));
  }

  /* « Je passe commande » → d'abord « Livraison ou à emporter ? », puis l'adresse si livraison */
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-order-cta], .cs-drawer .cs-btn[href], [data-csd-open]');
    if (!a) return;
    const on = () => enabled() || pickupOn();
    if (!CFG) { e.preventDefault(); await Promise.race([cfgP, new Promise((r) => setTimeout(r, 1500))]); if (!on()) { if (a.href) location.href = a.href; return; } }
    else if (!on()) return;
    e.preventDefault();
    const drawer = $('#cs-drawer');
    if (drawer && drawer.classList.contains('is-open')) { const c = $('[data-drawer-close]'); c && c.click(); }
    const href = a.getAttribute('href') || a.dataset.href || '/collections/all';
    if (a.hasAttribute('data-csd-cart')) { setMode('livraison'); openModal({ mode: 'cart', href }); return; }
    if (pickupOn()) { openChoice(href); return; }
    openModal({ mode: 'menu', href });
  }, true);
  // Panier : boutons « Livraison à domicile / À emporter ».
  document.addEventListener('change', (e) => {
    const r = e.target.closest('.cs-mode input'); if (!r || !r.checked || !pickupOn()) return;
    const m = r.value === 'retrait' ? 'emporter' : 'livraison';
    if (m === getMode()) return;
    setMode(m);
    if (m === 'livraison' && enabled()) { const st = load(); if (!st || st.out) openModal({ mode: 'cart' }); }
  });
  // Lien « Je préfère être livré » (page de commande) et autres raccourcis.
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-csd-mode]'); if (!b) return;
    e.preventDefault();
    const m = b.dataset.csdMode;
    setMode(m);
    if (m === 'livraison' && enabled()) { const st = load(); if (!st || st.out) openModal({ mode: 'cart' }); }
  });

  /* ---------------- Écran 3 : panier ---------------- */
  const TRUCK = '<svg width="38" height="30" viewBox="0 0 38 30" aria-hidden="true"><g fill="none" stroke="#111" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"><path d="M2 5h20v15H2zM22 10h7l6 6v4h-13z"/><circle cx="9" cy="23" r="3.4" fill="#fff6cf"/><circle cx="28" cy="23" r="3.4" fill="#fff6cf"/><path d="M5 9h7M5 13h5"/></g></svg>';
  function setCheckout(c, blocked, why) {
    const btn = $('[data-checkout]', c); if (!btn || window.CSOpen === false) return;
    btn.classList.toggle('csd-blocked', blocked);
    btn.setAttribute('aria-disabled', String(blocked));
    btn.dataset.csdWhy = why || '';
    btn.innerHTML = blocked && why === 'address' ? 'Indiquez votre adresse <span aria-hidden="true">↑</span>' : 'Valider ma commande <span aria-hidden="true">›</span>';
  }
  const BAG = '<svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><g fill="none" stroke="#111" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"><path d="M6 11h22l-2 19H8z" fill="#fff6cf"/><path d="M12 14V9a5 5 0 0 1 10 0v5"/></g></svg>';
  /* Ligne « Frais de livraison » et total du récapitulatif (texte d'origine mémorisé pour pouvoir le remettre). */
  function setSummary(c, feeText, totalCents) {
    $$('.cs-summary div', c).forEach((row) => {
      const dt = $('dt', row), dd = $('dd', row); if (!dt || !dd) return;
      if (!dt.dataset.orig) dt.dataset.orig = dt.textContent;
      if (!dd.dataset.orig) { dd.dataset.orig = dd.textContent; dd.dataset.origMuted = dd.classList.contains('cs-muted') ? '1' : ''; }
      const isFee = /^Frais|^Retrait/.test(dt.dataset.orig.trim());
      if (feeText === null) { dt.textContent = dt.dataset.orig; dd.textContent = dd.dataset.orig; dd.classList.toggle('cs-muted', dd.dataset.origMuted === '1'); return; }
      if (isFee) { dd.classList.remove('cs-muted'); if (feeText.label) dt.textContent = feeText.label; else dt.textContent = dt.dataset.orig; dd.textContent = feeText.value; }
      if (row.classList.contains('cs-summary__total')) dd.textContent = eur2(totalCents);
    });
  }
  function syncModes(c) {
    const opt = $('[data-csd-pickup-opt]', c); if (opt && pickupOn()) opt.hidden = false;
    const m = getMode();
    $$('.cs-mode input', c).forEach((r) => { r.checked = (r.value === 'retrait') === (m === 'emporter'); const l = r.closest('.cs-mode'); if (l) l.classList.toggle('is-on', r.checked); });
    const note = $('[data-csd-paynote]', c);
    if (note) { if (!note.dataset.orig) note.dataset.orig = note.textContent; note.textContent = m === 'emporter' ? '💵 💳 Paiement au comptoir quand vous venez chercher votre commande · aucun paiement en ligne' : note.dataset.orig; }
  }
  function renderCart() {
    const c = $('[data-cart]'); const box = c && $('[data-csd-cartbox]', c);
    if (!box || !(enabled() || pickupOn())) return;
    syncModes(c);
    const sub = +box.dataset.subtotal || 0, total = +box.dataset.total || sub;
    if (getMode() === 'emporter') {
      const p = pickupCfg(), min = p.min_cents || 0, left = Math.max(0, min - sub), pct = min ? Math.min(100, Math.round((sub / min) * 100)) : 100;
      box.hidden = false;
      $$('.cs-free', c).forEach((x) => { x.hidden = true; });
      box.innerHTML = `<div class="csd-cartmin__top">${BAG}<div><strong>À emporter${min ? ` · minimum ${eur(min)}` : ''}</strong><small>Retrait au restaurant${p.label ? ' : ' + esc(p.label) : ''}</small></div></div>
        ${min ? `<div class="csd-bar" role="progressbar" aria-valuemin="0" aria-valuemax="${min}" aria-valuenow="${Math.min(sub, min)}" aria-label="Progression vers le minimum de commande"><i style="width:0"></i></div>
        <div class="csd-cartmin__nums">${eur2(sub)} / ${eur(min)}</div>
        <p class="csd-cartmin__msg ${left ? 'is-ko' : 'is-ok'}">${left ? `Encore ${eur2(left).replace(',00', '')} pour atteindre le minimum de commande` : '✓ Minimum de commande atteint !'}</p>` : ''}
`;
      if (min) requestAnimationFrame(() => requestAnimationFrame(() => { const i = $('.csd-bar i', box); if (i) i.style.width = pct + '%'; }));
      setSummary(c, { label: 'Retrait au restaurant', value: 'Gratuit' }, total);
      setCheckout(c, left > 0, left > 0 ? 'minimum' : '');
      return;
    }
    if (!enabled()) {
      // Livraison choisie, mais le minimum par distance n'est pas encore activé : panier comme avant.
      box.innerHTML = ''; box.hidden = true;
      $$('.cs-free', c).forEach((x) => { x.hidden = false; });
      setSummary(c, null, total);
      setCheckout(c, false, '');
      return;
    }
    const st = load();
    box.hidden = false;
    $$('.cs-free', c).forEach((x) => { x.hidden = true; });
    if (!st || st.out) {
      box.innerHTML = `<div class="csd-cartmin__top">${TRUCK}<div><strong>Indiquez votre adresse de livraison</strong><small>${st && st.out ? 'Votre dernière adresse est hors de notre zone de livraison.' : 'Le minimum de commande dépend de la distance entre vous et Chez Smash.'}</small></div></div>
        <button type="button" class="csd-cta" data-csd-open data-csd-cart>Vérifier mon adresse</button>`;
      setSummary(c, null, total);
      setCheckout(c, true, 'address');
      return;
    }
    const min = st.min_cents, left = Math.max(0, min - sub), pct = min ? Math.min(100, Math.round((sub / min) * 100)) : 100;
    const city = originCity();
    box.innerHTML = `<div class="csd-cartmin__top">${TRUCK}<div><strong>Commande minimum : ${eur(min)}</strong><small>Vous êtes à ${km1(st.distance_km)} km de Chez Smash${city ? ` (${esc(city)})` : ''}</small></div></div>
      <div class="csd-bar" role="progressbar" aria-valuemin="0" aria-valuemax="${min}" aria-valuenow="${Math.min(sub, min)}" aria-label="Progression vers le minimum de commande"><i style="width:0"></i></div>
      <div class="csd-cartmin__nums">${eur2(sub)} / ${eur(min)}</div>
      <p class="csd-cartmin__msg ${left ? 'is-ko' : 'is-ok'}">${left ? `Encore ${eur2(left).replace(',00', '')} pour atteindre le minimum de commande` : '✓ Minimum de commande atteint !'}</p>
      <button type="button" class="csd-link" data-csd-open data-csd-cart>Livraison : ${esc(st.label)} · Modifier l’adresse</button>`;
    requestAnimationFrame(() => requestAnimationFrame(() => { const i = $('.csd-bar i', box); if (i) i.style.width = pct + '%'; }));
    // Frais du palier et total dans le récapitulatif
    setSummary(c, { label: '', value: st.fee_cents ? eur2(st.fee_cents) : 'Offerte' }, total + (st.fee_cents || 0));
    setCheckout(c, left > 0, left > 0 ? 'minimum' : '');
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-checkout].csd-blocked'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.dataset.csdWhy === 'address') return openModal({ mode: 'cart' });
    const box = $('[data-csd-cartbox]'); if (box) { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); box.animate && box.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 }); }
  }, true);
  // Le panier est réaffiché après chaque changement de quantité : on remet l'encart à jour.
  if ($('[data-cart]')) {
    new MutationObserver(() => { const box = $('[data-csd-cartbox]'); if (box && !box.dataset.csdOn) { box.dataset.csdOn = '1'; renderCart(); } })
      .observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('csd:change', () => renderCart());

  /* ---------------- Démarrage ---------------- */
  cfgP.then(() => {
    if (!enabled() && !pickupOn()) return;
    if (enabled()) $$('[data-csd-only]').forEach((el) => { el.hidden = false; });
    const box = $('[data-csd-cartbox]'); if (box) { box.dataset.csdOn = '1'; renderCart(); }
  });
})();
